import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RouteSignalRGroupService } from '@rocksoft/shared';
import { ToastContainerComponent } from '@rocksoft/shared/toast';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly routeSignalRService = inject(RouteSignalRGroupService);
  private readonly router = inject(Router);

  title = 'era-cms';
  private subscriptions: Subscription[] = [];

  constructor() {
    this.subscriptions.push(
      this.oidcSecurityService.checkAuthMultiple().subscribe(([{ isAuthenticated }]) => {
        if (isAuthenticated) {
          const savedRouteForRedirect = sessionStorage.getItem('redirect');
          if (savedRouteForRedirect) {
            sessionStorage.removeItem('redirect');
            void this.router.navigateByUrl(savedRouteForRedirect);
          }
        }
      })
    );
  }

  ngOnInit(): void {
    // Initialize route-driven SignalR group management
    this.routeSignalRService.initialize().catch((error: unknown) => {
      console.error('Failed to initialize route SignalR group service:', error);
    });
  }

  ngOnDestroy(): void {
    // Cleanup SignalR groups
    this.routeSignalRService.cleanup().catch((error: unknown) => {
      console.error('Failed to cleanup route SignalR group service:', error);
    });

    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
